import React, { useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { useMutation } from '@apollo/react-hooks';
import { growlActionSuccess, growlErrors } from '../../../../utils/NotificationUtil';
import gql from 'graphql-tag';

const REQUEST_RESPONDENT_EMPLOYMENT_CONFIRMATION = gql`
  mutation requestRespondentEmploymentConfirmation($input: RequestEmploymentConfirmationInput!) {
    requestRespondentEmploymentConfirmation(input: $input) {
        respondentId
        accountId 
    }
  }
`;

const RespondentEmploymentConfirmationDialog = ({ displayEmploymentConfirmationDialog, respondentId, hide }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [requestRespondentEmploymentConfirmationMutation, { loading }] = useMutation(
    REQUEST_RESPONDENT_EMPLOYMENT_CONFIRMATION,
  );

  const requestRespondentEmploymentConfirmation = async () => {
    try {
      await requestRespondentEmploymentConfirmationMutation({
        variables: {
          input: {
            accountId: currentAccount,
            respondentId: respondentId,
          },
        },
      });

      growlActionSuccess(growl, 'Employment confirmation request sent!');
      hide();
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  return (
    <Dialog visible={displayEmploymentConfirmationDialog} onHide={hide} modal>
      <div className="align-center">
        <h3>Did you hire the SuperMatch candidate?</h3>
      </div>
      <div className="mt20 flex-center">
        <Button
          type="button"
          disabled={loading}
          className="p-button-primary"
          label="Yes"
          onClick={requestRespondentEmploymentConfirmation}
        />
        <Button type="button" disabled={loading} className="p-button-primary" label="No" onClick={hide} />
      </div>
      <div className="mt25 align-center">
        If 'Yes', the SuperMatch candidate is asked to confirm. If confirmed, the SuperMatch candidate is automatically
        changed from external to internal.
      </div>
    </Dialog>
  );
};

export default RespondentEmploymentConfirmationDialog;
